import { Box, Button, TextField, MenuItem, IconButton, Typography } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import { fetchAdelantoView, PostDatosAdelanto, fetchAdelantoPreview } from "../../services/adelanto.services";
import * as XLSX from "xlsx";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Table, TableHead, TableRow, TableCell, TableBody, Tabs, Tab, Divider
} from "@mui/material";
const months = [
  { value: 1, label: "Enero" },
  { value: 2, label: "Febrero" },
  { value: 3, label: "Marzo" },
  { value: 4, label: "Abril" },
  { value: 5, label: "Mayo" },
  { value: 6, label: "Junio" },
  { value: 7, label: "Julio" },
  { value: 8, label: "Agosto" },
  { value: 9, label: "Septiembre" },
  { value: 10, label: "Octubre" },
  { value: 11, label: "Noviembre" },
  { value: 12, label: "Diciembre" },
];

// Generate years range (e.g., current year ± 5)
const currentYear = new Date().getFullYear();
const years = Array.from({ length: 13 }, (_, i) => currentYear - 5 + i);

const BG_MODAL   = "rgb(36, 43, 67)";
const TEXT_DARK  = "rgb(36, 43, 67)";
const BTN_BLUE   = "rgb(62, 67, 150)";
const HEADER_BG  = "rgb(26, 32, 53)";
const ROW_EVEN   = "rgba(255,255,255,0.06)";
const BORDER_CLR = "rgba(255,255,255,0.12)";

const RegistroAdelanto = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const theme = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [openPreview, setOpenPreview] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

// ── agrupar datos por empresa ─────────────────────────────────────────────
  const agrupadoPorEmpresa = previewData.reduce((acc, u) => {
    const empresa = u.empresa || "SIN EMPRESA";
    if (!acc[empresa]) acc[empresa] = [];
    acc[empresa].push(u);
    return acc;
    
  }, {});
  const empresas = Object.keys(agrupadoPorEmpresa).sort();
 const resumenPorEmpresa = empresas.map((empresa) => {
  const empleados = agrupadoPorEmpresa[empresa] || [];
  const conTarjeta = empleados.filter(
    (e) => e.nro_cuenta && e.nro_cuenta.trim() !== ""
  ).length;
  const sinTarjeta = empleados.length - conTarjeta;

  return {
    empresa,
    total: empleados.length,
    conTarjeta,
    sinTarjeta,
  };
});

const totalFuncionarios = resumenPorEmpresa.reduce((acc, r) => acc + r.total, 0);
const totalConTarjeta = resumenPorEmpresa.reduce((acc, r) => acc + r.conTarjeta, 0);
const totalSinTarjeta = resumenPorEmpresa.reduce((acc, r) => acc + r.sinTarjeta, 0);
  const totalGeneral = previewData.reduce(
    (sum, u) => sum + (Number(u.adelanto) || 0),
    0
  );

const mapearRegistros = (registros) => {
  const mapeados = registros
    .filter((item) => Number(item.adelanto) > 0)
    .map((item) => ({
      nroCuenta: item.nro_cuenta || "00000000",
      denominacion: item.nombre.toUpperCase().trim(),
      salario: Math.trunc(Number(item.adelanto)),
      cedula: item.cedula || "0000000",
      empresa: item.empresa || "SIN EMPRESA",      // ← agregar
      cod_empresa: item.cod_empresa,                // ← agregar
    }));

  return mapeados.sort((a, b) =>
    a.denominacion.localeCompare(b.denominacion, "es", { sensitivity: "base" })
  );
};


  const generarTXT = (registros) => {
  if (!registros || registros.length === 0) return;

  let contenido = "NRO_CUENTA\tDENOMINACION\tSALARIO\tCEDULA\n";

  registros.forEach((r) => {
    contenido += `${r.nroCuenta}\t${r.denominacion}\t${r.salario}\t${r.cedula}\n`;
  });

  const blob = new Blob([contenido], {
    type: "text/plain;charset=utf-8",
  });

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = "adelantos.txt";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

const exportarExcel = (registros) => {
  const workbook = XLSX.utils.book_new();

  // Agrupar registros por empresa
  const porEmpresa = registros.reduce((acc, r) => {
    const empresa = r.empresa || "SIN EMPRESA";
    if (!acc[empresa]) acc[empresa] = [];
    acc[empresa].push(r);
    return acc;
  }, {});

  // Crear una hoja por cada empresa
  Object.entries(porEmpresa).forEach(([empresa, empleados]) => {
    const worksheet = XLSX.utils.json_to_sheet(
      empleados.map((r) => ({
        NRO_CUENTA: r.nroCuenta,
        DENOMINACION: r.denominacion,
        SALARIO: r.salario,
        CEDULA: r.cedula,
      }))
    );

    // Excel limita los nombres de hoja a 31 caracteres y no permite ciertos caracteres
    const nombreHoja = empresa.substring(0, 31).replace(/[\\/:*?[\]]/g, "");
    XLSX.utils.book_append_sheet(workbook, worksheet, nombreHoja);
  });

  XLSX.writeFile(workbook, "adelantos.xlsx");
};

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    try {
      const response = await PostDatosAdelanto(values);
      // console.log("🚀 ~ handleFormSubmit ~ response:", response)

      const registrosView = await fetchAdelantoView(values.month, values.year);
      // console.log("🚀 ~ handleFormSubmit ~ registros:", registrosView)
      const registros = mapearRegistros(registrosView);
      // generarTXT(registros);
      exportarExcel(registros);
      setRegistrationSuccess(true);
      resetForm();
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

    // ── estilos de impresión inyectados en <style> ────────────────────────────
const printStyles = `
  @media print {
    /* Ocultamos todo lo que no sea el área de impresión */
    body * { visibility: hidden !important; }
    
    #adelanto-print-area,
    #adelanto-print-area * { visibility: visible !important; }

    #adelanto-print-area {
      /* CAMBIO CLAVE: Quitamos position: fixed e inset: 0 */
      position: absolute; 
      left: 0;
      top: 0;
      width: 100%;
      padding: 0; /* Deja que los márgenes del navegador controlen esto o usa cm/in */
      background: #fff !important;
      color: ${TEXT_DARK} !important;
    }

    /* Asegurar que las tablas no se corten de forma extraña */
    table { 
      width: 100%; 
      border-collapse: collapse; 
      page-break-inside: auto; 
    }
    tr { page-break-inside: avoid; page-break-after: auto; }
    
    .no-print { display: none !important; }
    
    /* Forzar que el fondo de las celdas se imprima (algunos navegadores lo bloquean) */
    th { 
      background: #e8eaf6 !important; 
      -webkit-print-color-adjust: exact; 
      print-color-adjust: exact; 
    }
  }
`;

   // ── render tabla por empresa (para pantalla y para impresión) ─────────────
  const TablaEmpresa = ({ empleados, empresa, forPrint = false }) => {
    const totalEmpresa = empleados.reduce(
      (sum, u) => sum + (Number(u.adelanto) || 0),
      0
    );
    const cellSx = forPrint
      ? { color: TEXT_DARK, border: "1px solid #ccc", py: 0.8, px: 1 }
      : { color: "#fff", borderBottom: `1px solid ${BORDER_CLR}`, py: 1 };
    const headSx = forPrint
      ? { fontWeight: 700, color: TEXT_DARK, backgroundColor: "#e8eaf6", border: "1px solid #ccc", py: 0.8, px: 1 }
      : { fontWeight: 700, color: "rgba(255,255,255,0.6)", borderBottom: `1px solid ${BORDER_CLR}`, py: 1, fontSize: "0.75rem", letterSpacing: "0.08em" };
 
    return (
      <Box mb={forPrint ? 3 : 0}>
        {forPrint && (
          <Typography className="empresa-title" sx={{ color: TEXT_DARK, fontWeight: 700, mb: 1 }}>
            {empresa}
          </Typography>
        )}
        <Table size="small" sx={forPrint ? {} : { "& .MuiTableRow-root:nth-of-type(even)": { backgroundColor: ROW_EVEN } }}>
          <TableHead>
            <TableRow sx={forPrint ? {} : { backgroundColor: HEADER_BG }}>
              <TableCell sx={headSx}>Nombre</TableCell>
              <TableCell sx={headSx}>Cédula</TableCell>
              <TableCell sx={headSx}>Nro Cuenta</TableCell>
              {!forPrint && <TableCell sx={headSx}>Empresa</TableCell>}
              <TableCell sx={{ ...headSx, textAlign: "right" }}>Adelanto</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {empleados.map((u) => (
              <TableRow key={u.id}>
                <TableCell sx={cellSx}>{u.firstname} {u.lastname}</TableCell>
                <TableCell sx={cellSx}>{u.cedula}</TableCell>
                <TableCell sx={cellSx}>{u.nro_cuenta}</TableCell>
                {!forPrint && <TableCell sx={cellSx}>{u.empresa}</TableCell>}
                <TableCell sx={{ ...cellSx, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                  {Number(u.adelanto).toLocaleString("es-PY")}
                </TableCell>
              </TableRow>
            ))}
            {/* fila total por empresa */}
            <TableRow className="total-row" sx={forPrint ? {} : { backgroundColor: "rgba(62,67,150,0.25)" }}>
              <TableCell
                colSpan={forPrint ? 3 : 4}
                sx={{ ...cellSx, fontWeight: 700, color: forPrint ? TEXT_DARK : "#fff" }}
              >
                Total {empresa}
              </TableCell>
              <TableCell
                sx={{ ...cellSx, fontWeight: 700, textAlign: "right",
                  color: forPrint ? TEXT_DARK : "#90caf9",
                  fontVariantNumeric: "tabular-nums" }}
              >
                {totalEmpresa.toLocaleString("es-PY")}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    );
  };

  const handleCloseModal = () => {
    setRegistrationSuccess(false);
  };

  const handleCloseModalError = () => {
    setRegistrationError(false);
  };

  return (
    <Box m="20px">
      <style>{printStyles}</style>
      <Header title="Registro Adelanto" subtitle="Registro Adelanto" />

      {isLoading && <LoadingSpinner />}
      {registrationSuccess && (
        <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      )}
      {registrationError && (
        <ModalError
          open={registrationError}
          onClose={handleCloseModalError}
          error={error}
        />
      )}

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          monto: "",
          month: currentYear, // default to current month/year
          year: currentYear,
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{ "& > div": { gridColumn: isNonMobile ? undefined : "span 4" } }}
            >
              {/* <TextField
                fullWidth
                variant="filled"
                type="number"
                label="Monto"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.monto || ""}
                name="monto"
                error={!!touched.monto && !!errors.monto}
                helperText={touched.monto && errors.monto}
                sx={{ gridColumn: "span 4" }}
                inputProps={{ min: 0, step: "0.01" }}
              /> */}

              <TextField
                select
                label="Mes"
                name="month"
                value={values.month}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.month && !!errors.month}
                helperText={touched.month && errors.month}
                sx={{ gridColumn: "span 2" }}
              >
                {months.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Año"
                name="year"
                value={values.year}
                onChange={handleChange}
                onBlur={handleBlur}
                error={!!touched.year && !!errors.year}
                helperText={touched.year && errors.year}
                sx={{ gridColumn: "span 2" }}
              >
                {years.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
              </TextField>
            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
 <IconButton
                sx={{
                  background: BTN_BLUE,
                  color: "#fff",
                  borderRadius: "8px",
                  px: 1.5,
                  "&:hover": { background: "rgb(80, 86, 180)" },
                  transition: "background 0.2s",
                }}
                onClick={async () => {
                  try {
                    const data = await fetchAdelantoPreview();
                    setPreviewData(data);
                    setTabIndex(0);
                    setOpenPreview(true);
                  } catch (err) {
                    console.error("Error al cargar vista previa", err);
                  }
                }}
              >
                <VisibilityIcon />
              </IconButton>
              <Button type="submit" color="secondary" variant="contained">
                Registrar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
 {/* ── Modal de vista previa ────────────────────────────────────────── */}
      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        fullWidth
        maxWidth="lg"
        PaperProps={{
          sx: {
            backgroundColor: BG_MODAL,
            borderRadius: "16px",
            boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
            overflow: "hidden",
          },
        }}
      >
        {/* título */}
        <DialogTitle
          sx={{
            backgroundColor: HEADER_BG,
            color: "#fff",
            fontWeight: 700,
            fontSize: "1.1rem",
            letterSpacing: "0.04em",
            py: 2,
            px: 3,
            borderBottom: `1px solid ${BORDER_CLR}`,
          }}
        >
          Vista previa de adelantos
        </DialogTitle>
 
        {/* tabs por empresa */}
        <Box sx={{ backgroundColor: HEADER_BG, borderBottom: `1px solid ${BORDER_CLR}` }}>
          <Tabs
            value={tabIndex}
            onChange={(_, v) => setTabIndex(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              "& .MuiTab-root": { color: "rgba(255,255,255,0.5)", fontSize: "0.78rem", minWidth: 100 },
              "& .Mui-selected": { color: "#fff !important" },
              "& .MuiTabs-indicator": { backgroundColor: BTN_BLUE, height: 3 },
            }}
          >
            {/* Tab "Todas" */}
            <Tab label="Todas" />
            {empresas.map((e) => (
              <Tab key={e} label={e} />
            ))}
          </Tabs>
        </Box>
 
        <DialogContent
          sx={{
            backgroundColor: BG_MODAL,
            px: 3,
            py: 2,
            maxHeight: "55vh",
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: 6 },
            "&::-webkit-scrollbar-thumb": { background: "rgba(255,255,255,0.15)", borderRadius: 3 },
          }}
        >
          {/* tab "Todas" */}
          {tabIndex === 0 && empresas.map((empresa) => (
            <Box key={empresa} mb={3}>
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.45)",
                  fontSize: "0.7rem",
                  fontWeight: 700,
                  letterSpacing: "0.12em",
                  textTransform: "uppercase",
                  mb: 1,
                }}
              >
                {empresa}
              </Typography>
              <TablaEmpresa empleados={agrupadoPorEmpresa[empresa]} empresa={empresa} />
            </Box>
          ))}
 
          {/* tabs individuales por empresa */}
          {tabIndex > 0 && empresas[tabIndex - 1] && (
            <TablaEmpresa
              empleados={agrupadoPorEmpresa[empresas[tabIndex - 1]]}
              empresa={empresas[tabIndex - 1]}
            />
          )}
 
          {/* total general */}
          <Box
            mt={3}
            p={2}
            sx={{
              backgroundColor: "rgba(62,67,150,0.2)",
              border: `1px solid ${BTN_BLUE}`,
              borderRadius: "10px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "1rem" }}>
              TOTAL GENERAL
            </Typography>
            <Typography sx={{ color: "#90caf9", fontWeight: 800, fontSize: "1.15rem", fontVariantNumeric: "tabular-nums" }}>
              {totalGeneral.toLocaleString("es-PY")}
            </Typography>
          </Box>
          <Box
  mt={2}
  p={2}
  sx={{
    backgroundColor: "rgba(62,67,150,0.25)",
    border: `1px solid ${BTN_BLUE}`,
    borderRadius: "10px",
  }}
>
  <Typography sx={{ color: "#fff", fontWeight: 700, mb: 1 }}>
    Resumen de funcionarios (Tarjetas)
  </Typography>
  {resumenPorEmpresa.map((r) => (
    <Typography key={r.empresa} sx={{ color: "#90caf9", fontSize: "0.9rem" }}>
      {r.empresa}: {r.total} funcionarios 
      (Con tarjeta: {r.conTarjeta}, Sin tarjeta: {r.sinTarjeta})
    </Typography>
  ))}

  <Divider sx={{ my: 1, borderColor: "rgba(255,255,255,0.2)" }} />

  <Typography sx={{ color: "#fff", fontWeight: 700 }}>
    TOTAL FUNCIONARIOS: {totalFuncionarios}
  </Typography>
  <Typography sx={{ color: "#90caf9", fontWeight: 600 }}>
    Con tarjeta: {totalConTarjeta} | Sin tarjeta: {totalSinTarjeta}
  </Typography>
</Box>

        </DialogContent>
 
        {/* ── área oculta sólo para impresión ── */}
        <Box id="adelanto-print-area" sx={{ display: "none" }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700, mb: 2, color: TEXT_DARK }}>
            Reporte de Adelantos
          </Typography>
          {empresas.map((empresa) => (
            <TablaEmpresa
              key={empresa}
              empleados={agrupadoPorEmpresa[empresa]}
              empresa={empresa}
              forPrint
            />
          ))}
          <Typography className="total-general" sx={{ color: TEXT_DARK }}>
            TOTAL GENERAL: {totalGeneral.toLocaleString("es-PY")}
          </Typography>
        </Box>
 
        <DialogActions
          sx={{
            backgroundColor: HEADER_BG,
            borderTop: `1px solid ${BORDER_CLR}`,
            px: 3,
            py: 1.5,
            gap: 1,
          }}
        >
          <Button
            className="no-print"
            onClick={() => {
              // mostrar área de impresión y lanzar diálogo
              const el = document.getElementById("adelanto-print-area");
              if (el) el.style.display = "block";
              window.print();
              if (el) el.style.display = "none";
            }}
            sx={{
              backgroundColor: BTN_BLUE,
              color: "#fff",
              borderRadius: "8px",
              px: 2.5,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { backgroundColor: "rgb(80, 86, 180)" },
            }}
          >
            Imprimir
          </Button>
          <Button
            className="no-print"
            onClick={() => setOpenPreview(false)}
            sx={{
              color: "rgba(255,255,255,0.7)",
              borderRadius: "8px",
              px: 2,
              textTransform: "none",
              "&:hover": { backgroundColor: "rgba(255,255,255,0.08)" },
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  month: yup
    .number()
    .min(1, "Mes inválido")
    .max(12, "Mes inválido")
    .required("Mes requerido"),
  year: yup
    .number()
    .min(currentYear - 5, "Año inválido")
    .max(currentYear + 8, "Año inválido")
    .required("Año requerido"),
});

export default RegistroAdelanto;